export const policiesDiscountSubMenu = [{
  path: '/policies-discounts/list/:policyId(\\d+)',
  component: () => import('@/views/policies-discounts/list.vue'),
  name: 'schemeManagement.policiesDiscount.title',
  meta: {
    roles: ['Super Admin', 'Admin', 'Regional Manager', 'Zonal Manager'],
    title: 'schemeManagement.policiesDiscount.title',
    noCache: true,
    icon: 'auction',
    hidden: true
  }
}, {
  path: '/policies-discounts/edit/:id(\\d+)',
  component: () => import('@/views/policies-discounts/manage.vue'),
  name: 'schemeManagement.policiesDiscount.edit',
  props: {
    isEdit: true
  },
  meta: {
    title: 'schemeManagement.policiesDiscount.edit',
    noCache: true,
    activeMenu: '/policies-discounts/list/:policyId(\\d+)',
    hidden: true
  }
}, {
  path: '/policies-discounts/add/:policyId(\\d+)',
  component: () => import('@/views/policies-discounts/manage.vue'),
  name: 'schemeManagement.policiesDiscount.add',
  props: {
    isEdit: false
  },
  meta: {
    title: 'schemeManagement.policiesDiscount.add',
    noCache: true,
    activeMenu: '/policies-discounts/list/:policyId(\\d+)',
    hidden: true
  }
}];